import React, {useEffect} from 'react';
import {Container} from 'react-bootstrap';
import {NavigationBar} from '../components/NavigationBar';
import {ParallaxTitle} from '../components/ParallaxTitle';
import {TeamTimeline} from '../components/TeamTimeline';
import {Footer} from '../components/Footer';

export const TeamHistory = () => {

    useEffect(() => {
        document.title = "Histórico de equipo - FabLab UTFSM";
    });

    return (
        <Container className="fablab-page" fluid>                                
            <NavigationBar/>
            <ParallaxTitle title={"Histórico de equipo"}/>
            <TeamTimeline/>
            <Footer/>
        </Container>
    )
}
